import React, { useState, useEffect, useContext } from 'react';

//services
import AppVehicleService from '../../AppVehicleService';

//components
import LoadingSpinner from '../../../../shared/Loading/LoadingSpinner';

//images
import DefaultImage from '../../../../../assets/images/MyVehiclePlaceholder300x150.png';

//hooks
import { useRouter } from '../../../../shared/hooks/useRouter';
import { useCloudinary } from '../../../../shared/Cloudinary/hook/useCloudinary';

//context
import { DriverContext } from '../../../../context/driver/getDriverContext';

//styles
import {
  VehicleFormStyles,
  VehicleSpecContainerStyles,
} from '../../../../DriverStyles';
import {
  InputContainerStyles,
  InputStyles,
  SelectContainerStyles,
  SelectStyles,
  ButtonContainerStyles,
  ButtonSpanStyles,
} from '../../../../SharedStyles';

//helpers

const EditManualVehicle = (props) => {
  const { strings } = AppVehicleService;
  const { driver } = useContext(DriverContext);
  const router = useRouter();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  //image uploader
  const { cloudData, uploadImage } = useCloudinary({
    preset: 'vehicle_images',
    tags: [`${driver.firstName} ${driver.lastName}`, driver.id],
  });

  useEffect(() => {
    if (cloudData) {
      setData((v) => ({
        ...v,
        imagePath: cloudData.secure_url,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cloudData]);

  useEffect(() => {
    setData(props.vehicle);
  }, [props.vehicle]);

  const openDialog = () => {
    document.getElementById('inputUpload').click();
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const saveVehicle = async (e) => {
    e.preventDefault();
    setLoading(true);
    let res = await AppVehicleService.updateDriverVehicle(data);
    if (res) {
      router.history.push('/vehicle-list');
    }
  };

  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    let year = 2000;

    while (year <= currentYear + 2) {
      yearOptions.push(year);
      year++;
    }

    return yearOptions;
  };

  return (
    <>
      <VehicleFormStyles id='myForm' onSubmit={saveVehicle}>
        {loading && <LoadingSpinner />}
        <InputContainerStyles>
          <InputStyles
            type='text'
            maxLength='256'
            name='nickName'
            value={data.nickName || ''}
            placeholder={strings.nickname}
            onChange={handleChange}
            required
          />
          <InputStyles
            maxLength='256'
            name='make'
            value={data.make || ''}
            placeholder={strings.makePlaceholder}
            onChange={handleChange}
            required
          />
          <InputStyles
            maxLength='256'
            name='model'
            value={data.model || ''}
            placeholder={strings.modelPlaceholder}
            onChange={handleChange}
            required
          />
          <SelectContainerStyles>
            <SelectStyles
              name='year'
              onChange={handleChange}
              value={data.year || ''}
              required>
              <option value='' disabled>
                {strings.yearPlaceholder}
              </option>
              {getYearOptions().map((el) => (
                <option key={el} value={el}>
                  {el}
                </option>
              ))}
            </SelectStyles>
          </SelectContainerStyles>
          <InputStyles
            type='number'
            min='1'
            max='9999'
            name='allElectricRange'
            value={data.allElectricRange || ''}
            placeholder={strings.manualRange}
            onChange={handleChange}
            required
          />
          <InputStyles
            type='number'
            min='1'
            max='999'
            name='batteryCapacity'
            value={data.batteryCapacity || ''}
            placeholder={strings.manualBattery}
            onChange={handleChange}
            required
          />
          <SelectContainerStyles>
            <SelectStyles
              name='color'
              onChange={handleChange}
              value={data.color || ''}
              required>
              <option value='Not Listed'>{strings.colorSelect}</option>
              {strings.colors.map((color) => {
                return (
                  <option key={color} value={color}>
                    {color}
                  </option>
                );
              })}
            </SelectStyles>
          </SelectContainerStyles>
        </InputContainerStyles>
      </VehicleFormStyles>
      <VehicleSpecContainerStyles>
        <div className='Container-Title'>{strings.vehicleSpecs}</div>
        <div className='Image-Container'>
          <img
            src={data.imagePath ? data.imagePath : DefaultImage}
            alt='vehicle'
          />
          <input
            className='file-input'
            id='inputUpload'
            type='file'
            hidden
            accept='image/*'
            onChange={uploadImage}
          />
        </div>
        <ButtonContainerStyles margin='10px auto'>
          <ButtonSpanStyles inverse id='fileUpload' onClick={openDialog}>
            {strings.changeImage}
          </ButtonSpanStyles>
        </ButtonContainerStyles>
      </VehicleSpecContainerStyles>
    </>
  );
};

export default EditManualVehicle;
